"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var R = __importStar(require("./ramda"));
function rand(items) { return items[Math.floor(Math.random() * items.length)]; }
function $rand(items) { return function () { return rand(items); }; }
var firstNamesM = ["Adam", "Alan", "Alex", "Alexander", "Andrew", "Anthony", "Austin", "Benjamin", "Blake", "Brett", "Brian", "Cameron", "Charles", "Christian", "Christopher", "Daniel", "David", "Dennis", "Derek", "Dominic", "Douglas", "Edward", "Eric", "Ethan", "Evan", "Frank", "Gabriel", "George", "Gregory", "Harvey", "Henry", "Isaac", "Jack", "Jacob", "James", "Jason", "Jeremiah", "Jeremy", "Joe", "John", "Jonathan", "Joseph", "Joshua", "Justin", "Keith", "Kenneth", "Kevin", "Kurt", "Kyle", "Larry", "Levi", "Logan", "Louis", "Luke", "Malcolm", "Mark", "Matthew", "Maxwell", "Michael", "Nathan", "Nicholas", "Oliver", "Patrick", "Paul", "Perry", "Peter", "Philip", "Raymond", "Richard", "Robert", "Roger", "Ronald", "Roy", "Russell", "Samuel", "Scott", "Sean", "Seth", "Steven", "Thomas", "Timothy", "Travis", "Tyler", "Victor", "Walter", "Warren", "Wayne", "Willie", "Zachary"];
var firstNamesF = ["Mary", "Patricia", "Linda", "Barbara", "Elizabeth", "Jennifer", "Maria", "Susan", "Margaret", "Dorothy", "Lisa", "Nancy", "Karen", "Betty", "Helen", "Sandra", "Donna", "Carol", "Ruth", "Sharon", "Michelle", "Laura", "Sarah", "Kimberly", "Deborah", "Jessica", "Shirley", "Cynthia", "Angela", "Melissa", "Brenda", "Amy", "Anna", "Rebecca", "Virginia", "Kathleen", "Pamela", "Martha", "Debra", "Amanda", "Stephanie", "Carolyn", "Christine", "Marie", "Janet", "Catherine", "Frances", "Ann", "Joyce", "Diane", "Alice", "Julie", "Heather", "Teresa", "Doris", "Gloria", "Evelyn", "Jean", "Cheryl", "Mildred", "Katherine", "Joan", "Ashley", "Natalie", "Lauren", "Geraldine", "Kelly", "Caroline", "Hannah", "Marilyn", "Emily", "Rachel", "Nicole"];
var lastNames = ["Smith", "Jones", "Williams", "Brown", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "Harris", "Martin", "Thompson", "White", "Lopez", "Lee", "Gonzalez", "Clark", "Lewis", "Robinson", "Walker", "Perez", "Hall", "Young", "Allen", "Sanchez", "Wright", "King", "Scott", "Green", "Baker", "Adams", "Nelson", "Hill", "Ramirez", "Campbell", "Mitchell", "Roberts", "Carter", "Phillips", "Evans", "Turner", "Torres", "Parker", "Collins", "Edwards", "Stewart", "Flores", "Morris", "Nguyen", "Murphy", "Rivera", "Cook", "Rogers", "Morgan", "Peterson", "Cooper", "Reed", "Bailey", "Bell", "Gomez", "Kelly", "Howard", "Ward", "Cox", "Diaz", "Richardson", "Wood", "Watson", "Brooks", "Bennett", "Gray", "James", "Reyes", "Cruz", "Hughes", "Price", "Myers", "Long", "Foster", "Sanders", "Ross", "Morales", "Powell", "Sullivan", "Russell", "Ortiz", "Jenkins", "Gutierrez", "Perry", "Butler", "Barnes", "Fisher", "Henderson", "Coleman", "Simmons", "Patterson", "Jordan", "Reynolds", "Hamilton", "Graham", "Kim", "Gonzales", "Alexander", "Ramos", "Wallace", "Griffin", "West", "Cole", "Hayes", "Chavez", "Gibson", "Bryant", "Ellis", "Stevens", "Murray", "Ford", "Marshall", "Owens", "Mcdonald", "Harrison", "Ruiz", "Kennedy", "Wells", "Alvarez", "Woods", "Mendoza", "Castillo", "Olson", "Webb", "Washington", "Tucker", "Freeman", "Burns", "Henry", "Vasquez", "Snyder", "Simpson", "Crawford", "Jimenez", "Porter", "Mason", "Shaw", "Gordon", "Wagner", "Hunter", "Romero", "Hicks", "Dixon", "Hunt", "Palmer", "Robertson", "Black", "Holmes", "Stone", "Meyer", "Boyd", "Mills", "Warren", "Fox", "Rose", "Rice", "Moreno", "Schmidt", "Patel", "Ferguson", "Nichols", "Herrera", "Medina", "Ryan", "Fernandez", "Weaver", "Daniels", "Stephens", "Gardner", "Payne", "Kelley", "Dunn", "Pierce", "Arnold", "Tran", "Spencer", "Peters", "Hawkins", "Grant", "Hansen", "Castro", "Hoffman", "Hart", "Elliott", "Cunningham", "Knight", "Larsson", "Banks", "Barnett", "Baxter", "Caldwell", "Carr", "Chapman", "Clarke", "Cornish", "Davidson", "Davis", "Dennis", "Edmunds", "Ellison", "Fields", "Gill", "Glover", "Greene", "Hardacre", "Hodges", "Hudson", "Johnston", "Kemp", "Lambert", "Lawrence", "Lyman", "Macdonald", "Mackay", "Mann", "Morrison", "Newman", "Owen", "Parsons", "Paterson", "Poole", "Sharp", "Skinner", "Sutherland", "Underwood", "Walsh", "Wilkinson"];
var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
var companiesNames = [
    "Tech Innovations Inc.",
    "Nexa Solutions",
    "Global Widget Corp.",
    "Quantum Dynamics Ltd.",
    "NovaTech Enterprises",
    "AlphaWave Technologies",
    "BlueSky Innovators",
    "Vertex Solutions Inc.",
    "Apex Data Systems",
    "Spectrum Labs",
    "CyberFusion Innovations",
    "InnovateX Corporation",
    "Omega Robotics Group",
    "FusionTech Innovators",
    "Precision Analytics Solutions",
    "QuantumLogic Labs LLC",
    "SynthoWave Ventures",
    "SparkMatrix Technologies",
    "EliteCyber Inc.",
    "OmniSoft Labs",
    "Starlight Innovate",
    "TechHaven Innovations",
    "Nexus Dynamics Solutions",
    "InfinitiWave Ventures",
    "DataPulse Technologies",
    "IgniteIQ Innovate",
    "QuantumFusion Systems",
    "Visionary Enterprises",
    "HyperTech Innovators",
    "Catalyst Innovations",
    "Echelon Innovate Inc.",
    "Aurora Data Services Ltd.",
    "CyberNex Labs LLC",
    "InnovateCore Corporation",
    "DeltaWave Innovations",
    "Pinnacle Analytics Group",
    "Quantum Pulse Ventures",
    "SynergyTech Solutions Inc.",
    "Genesis Innovate Inc.",
    "AgileCyber Technologies",
    "RadiantSoft Innovations",
    "Singularity Ventures",
    "TechSphere Innovate",
    "QuantumNest Corporation",
    "InsightWave Solutions",
    "Apex Analytics Group LLC",
    "SynthoTech Innovations Inc.",
    "Omega Innovate Inc.",
    "SparkWave Dynamics Corp.",
    "Protonix Technologies Group",
    "QuantumQuest Labs Inc.",
    "InnovateGrid Solutions Ltd.",
    "Vortex Data Innovators",
    "NexaWave Innovations Inc.",
    "FusionEdge Technologies",
    "CyberFleet Innovators",
    "InfraTech Solutions Inc.",
    "Stratosphere Innovations Corp.",
    "QuantumLink Dynamics Ltd.",
    "VisionTech Innovate",
    "QuantumFusion Innovations LLC",
    "AlphaTech Solutions Inc.",
    "OmniWave Ventures",
    "TechNova Dynamics Inc.",
    "QuantumSphere Innovate",
    "InnovateWave Labs Inc.",
    "DataFusion Ventures",
    "Pulsar Analytics Group LLC",
    "VivaTech Innovations Inc.",
    "SparkTech Innovators Inc.",
    "IgniteWave Systems Inc.",
    "QuantumMatrix Innovations",
    "EliteTech Ventures",
    "ByteWave Technologies Inc.",
    "CyberWave Innovators",
    "InnovatePath Solutions Inc.",
    "Apex Innovations Group LLC",
    "QuantumPulse Dynamics Inc.",
    "Synergetic Analytics Solutions",
    "NexaTech Solutions Inc.",
    "AlphaWave Innovate Inc.",
    "PulseTech Dynamics Corp.",
    "QuantumWave Technologies Ltd.",
    "InnovateSync Solutions",
    "QuantumGrid Innovations Inc.",
    "FusionPoint Technologies",
    "Skyline Analytics Group Inc.",
    "TechMasters Innovate",
    "StellarTech Innovations Corp.",
    "QuantumBridge Dynamics Ltd.",
    "VertexWave Innovate",
    "InnovateWay Solutions LLC",
    "DataFusion Innovate",
    "QuantumQuest Innovations Inc.",
    "SparkCore Technologies Inc.",
    "SynthoSphere Dynamics Solutions",
    "InnovateHub Group",
    "QuantumNex Innovations Inc.",
    "VortexTech Solutions LLC",
    "QuantumSage Innovations Inc."
];
// You can access the company names using fakeCompanyNames[index]
var companiesIds = ["2501273", "1983952", "1975994", "1975570", "4773472"];
var guid = function () {
    function _p8(s) {
        if (s === void 0) { s = false; }
        var p = ("".concat(Math.random().toString(16), "000000000")).substr(2, 8);
        return s ? "-".concat(p.substr(0, 4), "-").concat(p.substr(4, 4)) : p;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
};
var faker = {
    int: {
        /** Generates a random integer between 0 and the provided number (inclusive). */
        max: function (maxValue) { return Math.floor(Math.random() * (maxValue + 1)); },
        /** Generates a random integer between the two provided numbers (inclusive). */
        between: function (minValue, maxValue) { return Math.floor(Math.random() * (maxValue + 1 - minValue)) + minValue; },
    },
    name: {
        firstName: $rand(__spreadArray(__spreadArray([], __read(firstNamesM), false), __read(firstNamesF), false)),
        firstNameF: $rand(firstNamesF),
        firstNameM: $rand(firstNamesM),
        lastName: $rand(lastNames)
    },
    date: {
        /** Returns a random date from the past.
         * @param maxDays The maximum number of days in the past from which to pick a random date. Defaults to 100.
         * @returns Date
        */
        past: function (maxDays) {
            if (maxDays === void 0) { maxDays = 100; }
            return new Date(Number(new Date()) - faker.int.max(maxDays) * 24 * 60 * 60 * 1000);
        },
        /** Returns a random date from the future.
         * @param maxDays The maximum number of days in the future from which to pick a random date. Defaults to 100.
         * @returns Date
         */
        future: function (maxDays) {
            if (maxDays === void 0) { maxDays = 100; }
            return new Date(Number(new Date()) + faker.int.max(maxDays) * 24 * 60 * 60 * 1000);
        },
        /**
         * Returns a random day of the week as a string.
         */
        weekday: $rand(weekday),
        /**
         * Returns a random month of the year as a string.
         */
        month: $rand(month),
    },
    company: {
        id: function (i) { return companiesIds[i]; },
        name: function (i) { return companiesNames[i]; },
        amount: function () { return (Math.floor(Math.random() * (10 * 100 - 1 * 100) + 1 * 100) / (1 * 100)); }
    },
    /** Generates a 5-part GUID.
     * @example
     *  const myGuid = faker.guid()
     *  console.log(myGuid) // "90f3afa3-aec9-c193-e2cc-f1b925832cd3"
      */
    guid: guid,
    /** Generates a random IPv4 address. */
    ip: function () { return R.times(function () { return faker.int.max(255); }, 4).join("."); },
    /** Picks a random value from the supplied array. */
    pick: rand
};
exports.default = __assign({}, faker);
